<template>
    <b-input-group id="search-container">
        <template v-slot:prepend>
            <b-dropdown :text="selectedOption.Text" >
                <b-dropdown-item v-for="(option, index) in searchOptions" @click="optionSelected(option)">{{option.Text}}</b-dropdown-item>
            </b-dropdown>
        </template>
        <b-form-input :autofocus="true" ref="searchBox" v-model.trim="searchText" placeholder="cauta..." type="text"></b-form-input>
        <b-input-group-append>
            <b-btn variant="outline-primary" @click="searchButtonClick"><i class="fa fa-search mr-1"></i>Cauta</b-btn>
            <b-btn variant="outline-primary" @click="deleteButtonClick"><i class="fa fa-remove"></i></b-btn>
        </b-input-group-append>
    </b-input-group>
</template>

<script type="text/javascript">

    export default {
        name: 'SearchBox',
        props: {
            searchDelay: {
                type: Number,
                default: 1000
            },
            defaultOption: null,
            searchOptions: {
                type: Array,
                default: function () {
                    return [
                        {
                            Text: 'CNP/CUI',
                            Value: 'UniqueId'
                        },
                        {
                            Text: 'Nr. inmatriculare',
                            Value: 'PlateNo'
                        },
                        {
                            Text: 'Nume proprietar',
                            Value: 'Name'
                        },
                        {
                            Text: 'Sasiu',
                            Value: 'ChassisNumber'
                        },
                        {
                            Text: 'Nr. comanda',
                            Value: 'Id'
                        },
                        {
                            Text: 'Nr. polita',
                            Value: 'PolicyNo'
                        },
                        {
                            Text: 'Orice',
                            Value: 'All'
                        }
                    ]
                },

            },
            
        },
        components: {
        },
        data: () => {
            return {
                timeoutObj: null,
                searchText: '',
                selectedOption: {
                        Text: 'Orice',
                        Value: 'All'
                },
            }
        },
        computed:
        {
            searchFilter: function () {
                return this.searchText;
            },
        },
        created() {
            console.log(this.defaultOption);
            if (this.defaultOption != undefined) {
                this.selectedOption = this.defaultOption;
            }
        },
        methods: {

            searchButtonClick: function () {

                if (this.searchText == '') {
                    this.$emit('searchTextChanged', '');
                    return;
                }

                if (this.selectedOption.Value != 'All') {
                    this.$emit('searchTextChanged', this.selectedOption.Value + ':' + this.searchText);
                }
                else {
                    this.$emit('searchTextChanged', this.searchText);
                }
            },
            searchTextChanged() {
                return;
                //reset timer if new change before timeout
                clearTimeout(this.timeoutObj);

                this.timeoutObj = setTimeout(() => {
                    console.log('searchTextChanged event emitted with value=' + this.searchText);

                    if (this.searchText == '') {
                        this.$emit('searchTextChanged', '');
                        return;
                    }

                    if (this.selectedOption.Value != 'All') {
                        this.$emit('searchTextChanged', this.selectedOption.Value + ':' + this.searchText);
                    }
                    else {
                        this.$emit('searchTextChanged', this.searchText);
                    }

                }, this.searchDelay);

            },

            deleteButtonClick() {
                this.searchText = '';
                this.$emit('searchTextChanged', this.searchText);
            },

            clear() {
                this.searchText = '';
            },

            optionSelected: function (option) {
                this.selectedOption = option;
                this.$refs.searchBox.focus();
                this.$refs.searchBox.select();
            }
        }
    }

</script>
